import React from "react";

function UlText({ children }: { children: string[] }) {
  return (
    <ul className="ml-7 whitespace-pre-wrap text-justify">
      {children.map((child, index) => (
        <li className="list-disc" key={index}>
          {child}
        </li>
      ))}
    </ul>
  );
}

export default UlText;
